import {
	getLearnOpportunityPath,
	getRootAndContentNodePath,
} from "../../infecto-lms-webapp-impl/router/routes/auth/nodes.routes";

export const selectCorrectPathToContent = (
	rootNodeId: string | undefined,
	contentNodeId: string,
	isNoMultipleChoiceElement: boolean,
) => {
	const rootId = rootNodeId || contentNodeId;
	return isNoMultipleChoiceElement
		? getLearnOpportunityPath(rootId!)
		: getRootAndContentNodePath(`${rootId}/${contentNodeId}`);
};
